import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Check } from 'lucide-react';
export function Guarantee() {
  return <section id="guarantee" className="section-padding bg-black text-white relative overflow-hidden" data-id="element-159">
      {/* Subtle texture/pattern overlay */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: `radial-gradient(#ffffff 1px, transparent 1px)`,
      backgroundSize: '20px 20px'
    }} data-id="element-160"></div>

      <div className="container-custom relative z-10" data-id="element-161">
        <div className="max-w-4xl mx-auto bg-navy border border-white/10 p-8 md:p-12 rounded-sm shadow-2xl" data-id="element-162">
          <div className="flex flex-col md:flex-row gap-10 items-center md:items-start" data-id="element-163">
            <div className="flex-shrink-0" data-id="element-164">
              <div className="w-24 h-24 rounded-full bg-white/5 border-2 border-amber flex items-center justify-center shadow-[0_0_30px_rgba(246,183,60,0.2)]" data-id="element-165">
                <ShieldCheck className="w-12 h-12 text-amber" data-id="element-166" />
              </div>
            </div>

            <div data-id="element-167">
              <span className="eyebrow text-amber" data-id="element-168">
                A Serious Guarantee for Serious Operators
              </span>
              <h2 className="text-3xl md:text-4xl font-bold mb-6 font-heading" data-id="element-169">
                A Consulting Engagement Built Around Measurable ROI
              </h2>

              <div className="space-y-4 text-white/80 text-lg leading-relaxed mb-8" data-id="element-170">
                <p data-id="element-171">
                  FleetScale backs qualifying 12-month consulting engagements
                  with a{' '}
                  <strong className="text-white" data-id="element-172">3X ROI commitment</strong> when
                  the client completes the program, creates the strategic plan
                  with FleetScale, and implements the agreed strategies,
                  tactics, and work through the coaching process.
                </p>
                <p data-id="element-173">
                  If the agreed ROI is not realized, FleetScale continues the
                  engagement at no additional cost until the ROI target is met.
                </p>
              </div>

              <div className="bg-black/50 border border-white/10 p-6 rounded-sm mb-8" data-id="element-174">
                <h4 className="text-sm font-bold uppercase tracking-wider text-white/60 mb-4" data-id="element-175">
                  What this requires:
                </h4>
                <ul className="grid sm:grid-cols-2 gap-3" data-id="element-176">
                  {['A full 12-month engagement', 'A shared strategic plan', 'Consistent communication', 'Implementation of agreed action items', 'Clear measurement of results'].map((item, i) => <li key={i} className="flex items-start" data-id="element-177">
                      <Check className="w-5 h-5 text-amber shrink-0 mr-2" data-id="element-178" />
                      <span className="text-sm text-white/90" data-id="element-179">{item}</span>
                    </li>)}
                </ul>
              </div>

              <a href="#contact" className="btn-primary group mt-4" data-id="element-180">
                Talk Through the Guarantee
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-arrow-right w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-181">
                  <path d="M5 12h14" data-id="element-182" />
                  <path d="m12 5 7 7-7 7" data-id="element-183" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}